module.exports = __webpack_public_path__ + "img/combojetvac_stopped.863f2dce.svg";